// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","flowers-ad":"flowers-ad","flowers-cta-header":"flowers-cta-header","flowers-cta-link":"flowers-cta-link","flowers-cta-items":"flowers-cta-items","flowers-cta-item":"flowers-cta-item","description":"description","image":"image"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Shared/FlowersAd/css/FlowersCTA.styl
// module id = 1538
// module chunks = 0